import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {NbFieldType, NbRatingShape} from "./nbinput.entity";


@Component({
  selector: 'nbinput-rating',
  template: require('./nbinput-rating.component.html'),
  styles: [require('./nbinput-rating.component.scss')],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NbinputRatingComponent),
      multi: true
    }
  ]
})

export class NbinputRatingComponent implements ControlValueAccessor{
  private onTouchedCallback = () => {};
  private onChangeCallback = (_) => {};
  registerOnChange(fn: any): void {if(fn)this.onChangeCallback = fn;}
  registerOnTouched(fn: any): void {if(fn)this.onTouchedCallback = fn;}
  setDisabledState?(isDisabled: boolean): void {this.disabled = isDisabled}
  writeValue(obj: number): void {
    if (this.data != obj) {
      this.data = obj;
    }
  }
  onBlur() {
    this.onTouchedCallback();
  }

  public _shape = ['fa-star-o','fa-star'];
  @Input()
  set shape(v:NbRatingShape){
    this._shape[1] = 'fa-'+v;
    this._shape[0] = 'fa-'+v+'-o';
  }

  @Input()
  color = '#ffd703';
  @Input()
  size = 24;

  set value(v:number){
    if (v != this.data){
      this.data = v;
      this.onChangeCallback(this.isNumeric(v)||v<0?v:0);
    }
  }
  get value(){
    return this.data;
  }
  _data:number = 3;
  @Input()
  set data(v:number){
    this._data = this.isNumeric(v)||v<0?v:0;
    let tmp = Array(this._max).fill(0);
    if (this._data>0){
      tmp.fill(1,0,this._data);
    } else {
      tmp.fill(0);
    }
    this.full = tmp;
  }
  get data(){
    return this._data;
  }
  _max:number = 5;
  @Input()
  set max(v:number){
    if (v && this.isNumeric(v)){
      this._max = v;
      this.full = Array(v).fill(0).fill(1,0,this._data);
    }
  }
  get max(){
    return this._max;
  }
  public full: Array<number> = [];

  isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  @Input()
  public disabled:boolean = false;

  changeData(i){
    if (!this.disabled){
      this.data = i+1;
    }
  }
}
